import { ApiBody } from './bot-data';

export interface CurlParserResponse {
  url: string;
  method: string;
  headers?: Record<string, string>;
  queryParams?: Record<string, string>;
  data?: Record<string, unknown>;
}

export enum ApiMethod {
  HEAD = 'HEAD',
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
}
export interface ChannelPartnerDetails {
  id: string;
  name: string;
  supportNumber: string;
  ownerId: string;
  logoUrl: string;
  domain: string;
  isOwner: boolean;
  privacyLink: string;
  tearOfServiceLink: string;
  recapthcaSiteKey: string;
  firebaseApiKey: string;
}

export enum ApiComponentFormat {
  TEXT = 'TEXT',
  IMAGE = 'IMAGE',
  DOCUMENT = 'DOCUMENT',
  VIDEO = 'VIDEO',
  LOCATION = 'LOCATION',
}

export enum ApiComponentTypes {
  HEADER = 'HEADER',
  BODY = 'BODY',
  FOOTER = 'FOOTER',
  BUTTON = 'BUTTON',
}

export enum ApiRequestBodyFormat {
  JSON = 'JSON',
  FORM_DATA = 'FORM_DATA',
  // X_WWW_FORM_URLENCODED = 'X_WWW_FORM_URLENCODED',
  FORM_URL_ENCODED = 'FORM_URL_ENCODED',
  RAW = 'RAW',
  BINARY = 'BINARY',
  NONE = 'NONE',
}

export interface Api {
  id: number;
  remoteId: string;
  apiName: string;
  components: ApiComponentsArray;
  language: string;
  apiMethod: ApiMethod;
  apiUrl: string;
  dateCreated: number;
  dateUpdated: number;
  integrationId: string;
  dateDeleted: number | null;
  createdBy: string;
  apiHeader: { key: string; value: string }[];
  apiParams: { key: string; value: string }[];
  pathParams: { key: string; value: string }[];
  apiBody: ApiBody;
  apiResponseHeaders: { key: string; value: string }[];
  apiResponse: { key: string; value: string | number | boolean }[];
  apiResponseString?: string;
  sampleRequestBody?: Record<string | number, string | number | boolean>;
  editable: boolean;
  deletable: boolean;
  requestBodyFormat: ApiRequestBodyFormat;
  newlyAdded?: boolean;
  apiResponseRawData?: string;
}

export type ApiComponentsArray = Array<ApiComponent>;

export type ApiComponent = ApiHeaderComponent | ApiBodyComponent | ApiFooterComponent | ApiButtonComponent;

export type ApiButtonTypes = ApiURLButton | ApiPhoneButton | ApiReplyButton;

export enum ApiButtonType {
  QUICK_REPLY = 'QUICK_REPLY',
  URL = 'URL',
  PHONE_NUMBER = 'PHONE_NUMBER',
}

export interface ApiURLButton {
  type: ApiButtonType.URL;
  url: string;
  example?: string;
  text: string;
}

export interface ApiPhoneButton {
  type: ApiButtonType.PHONE_NUMBER;
  phoneNumber: string;
  text: string;
}

export interface ApiReplyButton {
  type: ApiButtonType.QUICK_REPLY;
  text: string;
}

export interface ApiButtonComponent {
  type: ApiComponentTypes.BUTTON;
  buttons: Array<ApiButtonTypes>;
}
export interface ApiTextHeaderComponent {
  format: ApiComponentFormat.TEXT;
  text: string;
  example?: Record<string, string>;
}

export interface ApiMediaHeaderComponent {
  format: ApiComponentFormat.IMAGE | ApiComponentFormat.VIDEO | ApiComponentFormat.DOCUMENT;
  example: {
    link: string;
  };
  link?: string;
}

export type ApiHeaderComponent = {
  type: ApiComponentTypes.HEADER;
} & (ApiTextHeaderComponent | ApiMediaHeaderComponent);

export interface ApiBodyComponent {
  type: ApiComponentTypes.BODY;
  text: string;
  example?: Record<string, string>;
}

export interface ApiFooterComponent {
  type: ApiComponentTypes.FOOTER;
  text: string;
}

export interface ApiTestResponse {
  headers: Record<string, string>;
  data: Record<string, string | number | boolean>;
  status: number;
  statusText: string;
  message?: string;
  name?: string;
  response?: string;
  rawData?: string;
}

export enum FormDataItemType {
  TEXT = 'TEXT',
  FILE = 'FILE',
}

export interface ApiFormDataBodyItem {
  type: FormDataItemType;
  key: string;
  value: string | File[] | null;
}
